<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Feathered Bone</title>
<meta charset="utf-8"/>
<p class="ct2"><i>Contents</i></p>
<p class="cct"><a href="#/part01#tocp1" id="conp1">Part 1</a></p>
<p class="cct1"><a href="#/chapter01#toc1" id="con1">Chapter 1</a></p>
<p class="cct1"><a href="#/chapter02#toc2" id="con2">Chapter 2</a></p>
<p class="cct1"><a href="#/chapter03#toc3" id="con3">Chapter 3</a></p>
<p class="cct1"><span href="#/chapter04#toc4" id="con4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="cct1"><span href="#/chapter05#toc5" id="con5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="cct1"><span href="#/chapter06#toc6" id="con6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="cct1"><span href="#/chapter07#toc7" id="con7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="cct"><span href="#/part02#tocp2" id="conp2" title="Link target outside of Sample">Part 2</span></p>
<p class="cct1"><span href="#/chapter08#toc8" id="con8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="cct1"><span href="#/chapter09#toc9" id="con9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="cct1"><span href="#/chapter10#toc10" id="con10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="cct1"><span href="#/chapter11#toc11" id="con11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="cct1"><span href="#/chapter12#toc12" id="con12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="cct1"><span href="#/chapter13#toc13" id="con13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="cct1"><span href="#/chapter14#toc14" id="con14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="cct1"><span href="#/chapter15#toc15" id="con15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="cct1"><span href="#/chapter16#toc16" id="con16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="cct1"><span href="#/chapter17#toc17" id="con17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="cct1"><span href="#/chapter18#toc18" id="con18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="cct1"><span href="#/chapter19#toc19" id="con19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="cct1"><span href="#/chapter20#toc20" id="con20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="cct1"><span href="#/chapter21#toc21" id="con21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="cct1"><span href="#/chapter22#toc22" id="con22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="cct1"><span href="#/chapter23#toc23" id="con23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="cct"><span href="#/part03#tocp3" id="conp3" title="Link target outside of Sample">Part 3</span></p>
<p class="cct1"><span href="#/chapter24#toc24" id="con24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="cct1"><span href="#/chapter25#toc25" id="con25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="cct1"><span href="#/chapter26#toc26" id="con26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="cct1"><span href="#/chapter27#toc27" id="con27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="cct1"><span href="#/chapter28#toc28" id="con28" title="Link target outside of Sample">Chapter 28</span></p>
<p class="cct1"><span href="#/chapter29#toc29" id="con29" title="Link target outside of Sample">Chapter 29</span></p>
<p class="cct1"><span href="#/chapter30#toc30" id="con30" title="Link target outside of Sample">Chapter 30</span></p>
<p class="cct1"><span href="#/chapter31#toc31" id="con31" title="Link target outside of Sample">Chapter 31</span></p>
<p class="cct1"><span href="#/chapter32#toc32" id="con32" title="Link target outside of Sample">Chapter 32</span></p>
<p class="cctt"><span href="#/chapter33#toc33" id="con33" title="Link target outside of Sample">A Note from the Author</span></p>
<p class="cct"><span href="#/chapter34#toc34" id="con34" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cct"><span href="#/chapter35#toc35" id="con35" title="Link target outside of Sample">Discussion Questions</span></p>
<p class="cct"><span href="#/chapter35a#toc35a" id="con35a" title="Link target outside of Sample">An Excerpt from <i>Perennials</i></span></p>
<p class="cct1"><span href="#/chapter35d#toc35d" id="con35d" title="Link target outside of Sample">Prologue</span></p>
<p class="cct1"><span href="#/chapter35e#toc35e" id="con35e" title="Link target outside of Sample">One</span></p>
<p class="cct1"><span href="#/chapter35f#toc35f" id="con35f" title="Link target outside of Sample">Two</span></p>
<p class="cct"><span href="#/chapter37#toc36" id="con36" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4c0e37bb